import React, { useState, useEffect, createRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Swiper from 'swiper';
import CardsCarousel from '../../compositions/CardsCarousel';
import { CardActions } from '../../components';
import cardTypes from '../../helpers/cardTypes';
import { Wrapper, Container } from './common';
import { setActiveType } from '~/store/modules/home/actions';
import getCompanyFirstNameByIssuer from '~/helpers/getCompanyFirstNameByIssuer';

const CardDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .balance-management {
    width: 50%;
    max-width: 335px;
    overflow: hidden;
    .swiper-slide {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      &.blocked {
        align-items: center;
        justify-content: flex-start;
        height: 220px;
        & > * {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.devices.tablet}) {
    .balance-management {
      display: none;
    }
  }
`;

const Title = styled.h2`
  font-weight: bold;
  font-size: 26px;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 25px;
  margin-left: 1px;
  span {
    text-transform: capitalize;
  }
  height: 78px;
`;

const debounce = (() => {
  let time;
  return func => {
    clearTimeout(time);
    time = setTimeout(func);
  };
})();

const CardDetails = ({
  activeSlide,
  setActiveSlide,
  cards,
  handleClickedItem,
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [swiperDesktop, setSwiperDesktop] = useState();
  const swiperDesktopEl = createRef();
  const dispatch = useDispatch();
  const issuerName = useSelector(state => state?.issuer?.name);

  useEffect(() => {
    if (cards?.length > 0) {
      const activeType = cards?.[activeSlide];
      dispatch(setActiveType(activeType));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.onresize = () => {
      debounce(() => setScreenWidth(window.innerWidth));
    };
  }, []);

  useEffect(() => {
    if (screenWidth > 560 && !swiperDesktop && swiperDesktopEl) {
      setSwiperDesktop(
        new Swiper('.swiper-container-desktop', {
          direction: 'horizontal',
          loop: false,
          allowTouchMove: false,
        }),
      );
    }
    if (screenWidth < 561 && swiperDesktop) {
      swiperDesktop.destroy(true);
      setSwiperDesktop(null);
    }
  }, [swiperDesktop, swiperDesktopEl, screenWidth]);

  useEffect(() => {
    const activeType = cards?.[activeSlide];
    if (swiperDesktop && screenWidth > 560) {
      swiperDesktop.slideTo(activeSlide);
      dispatch(setActiveType(activeType));
    }
    // eslint-disable-next-line
  }, [activeSlide]);

  const companyFirstName = getCompanyFirstNameByIssuer(issuerName);

  return (
    <>
      {screenWidth > 560 ? (
        <Container>
          <Wrapper>
            <CardDetailsContainer>
              <CardsCarousel.Desktop
                activeSlide={activeSlide}
                onChange={setActiveSlide}
                slides={cards}
              />
              <div className="balance-management cardinfo-step">
                <div className="swiper-container-desktop" ref={swiperDesktopEl}>
                  <div className="swiper-wrapper">
                    {cards.map((card, i) => (
                      <div
                        className={`swiper-slide ${
                          card.statusCartao !== 3 ? 'blocked' : ''
                        }`}
                        key={i}
                      >
                        <Title>
                          <span>{`${companyFirstName} ${
                            cardTypes[card.codigoProduto]
                          }`}</span>
                        </Title>
                        <CardActions
                          card={card}
                          onClick={clickedItem =>
                            handleClickedItem(clickedItem)
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </CardDetailsContainer>
          </Wrapper>
        </Container>
      ) : (
        <CardsCarousel.Mobile
          activeSlide={activeSlide}
          onChange={setActiveSlide}
          slides={cards}
        />
      )}
    </>
  );
};

CardDetails.propTypes = {
  activeSlide: PropTypes.number.isRequired,
  setActiveSlide: PropTypes.func.isRequired,
  cards: PropTypes.array.isRequired,
  handleClickedItem: PropTypes.func.isRequired,
};

export default CardDetails;
